import { render, staticRenderFns } from "./dialog-quarternary.vue?vue&type=template&id=6f70f054&scoped=true&"
import script from "./dialog-quarternary.vue?vue&type=script&lang=js&"
export * from "./dialog-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f70f054",
  null
  
)

export default component.exports